define('bizzabo/models/Poll',[
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/consts',
    'backbone',
    'backbone-validation',
    'bizzabo/models/ValidationObject',
    'underscore',
    'bizzabo/models/SyncedModel',
    'bizzabo/models/Questions',
    'timezoneJS'
], function(
    BZAPI,
    UTILS,
    Consts,
    Backbone,
    BackboneValidation,
    ValidationObject,
    _,
    SyncedModel,
    Questions,
    timezoneJS

    ) {

    var Poll = SyncedModel.extend({

        defaults : {
            'show-results' : true,
            'share-poll' : true,
            'start-method' : 'manual',
            'show-inactive' : true
        },

        sync : function(method, model, options) {
            var thisEventId = this.get('eventId') ? this.get('eventId') : this.collection.eventId;

            if (method == 'delete') {
                BZAPI.deletePoll(this.get('id'), function(data) {
                    options.success && options.success(data, options);
                }, options.error);
            } else if (method == 'update') {
                BZAPI.updatePoll(thisEventId, {poll: model.toJSON()}, function(data) {
                    options.success && options.success(data, options);
                    model.setQuestionsIndices();
                    model.setFlagsAfterSync();
                    model.shouldFetch = false;
                    model.wasChanged = false;
                }, options.error);
            } else if (method == 'create') {
                BZAPI.createPoll(thisEventId, {poll: model.toJSON()}, function(data) {
                    options.success && options.success(data, options);
                    model.setFlagsAfterSync();
                    model.shouldFetch = false;
                    model.wasChanged = false;
                }, options.error);
            }
        },

        initialize : function(map) {
            if (map && map['questions']) {
                var newQuestions = new Questions(map['questions']);
                this.set('questions', newQuestions);
            } else {
                this.set('questions', new Questions());
            }
            this.validationObject = new ValidationObject(this);
        },

        clonePoll : function() {
            var pollJson = JSON.parse(JSON.stringify(this.toJSON()));
            UTILS.applyRecursively(pollJson, function(obj, value, key) {
                if (key == 'id' || key == 'client-id' || key == 'public-url' || key == 'vote-count') {
                    delete obj[key];
                }
            });

            return new Poll(pollJson, {parse: true});
        },

        unsetDates : function() {
            this.unset('start-timestamp');
            this.unset('end-timestamp');
        },

        isAllModelValid : function(validate) {
            var questions = this.get('questions');
            var isQuestionsValid = true;
            questions.each(function(question){
                isQuestionsValid = question.isAllModelValid(validate) && isQuestionsValid;
            });
            return (this.isValid(validate) && isQuestionsValid);
        },

        setQuestionsIndices : function() {
            var pollsQuestions = this.get('questions');
            pollsQuestions.updateModelsIndex();
            _.each(pollsQuestions.models, function(question) {
                if (question) {
                    question.setAnswersIndices();
                }
            });
        },

        parse : function(response) {
            this.assimilateJson(response);
            return this.attributes;
        },

        clearResults : function(options) {
            BZAPI.clearPollResults(this.get('id'), options.success, options.error)
        },

        startPollNow : function() {
            this.set('start-timestamp', Date.now());
            this.unset('end-timestamp');
        },

        validateStartTimestamp : function(value) {

            if (_.isUndefined(value)) {
                return; // not required
            }
            if (value == "") {
                return "Start time is required";
            }

            if (this.get('end-timestamp') < value) {
                return "Flipped end and start time";
            }
        },

        setTimestampBySession : function(timeStamp, timeZone, session, dayIndex) {
            var thisModel = this;

            var generateTimestamp = function(startOrEnd) {
                var sessionDate = new timezoneJS.Date(timeStamp, timeZone);
                var sessionTimeSplit = session.get(startOrEnd).split(':');

                sessionDate.setTimezone(timeZone);
                sessionDate.setTime(timeStamp);
                sessionDate.setDate(sessionDate.getDate() + dayIndex);
                sessionDate.setHours(parseInt(sessionTimeSplit[0], 10));
                sessionDate.setMinutes(parseInt(sessionTimeSplit[1], 10));
                thisModel.set(startOrEnd + '-timestamp', sessionDate.getTime());
            };

            generateTimestamp('start');
            generateTimestamp('end');
        },

        validation : {
            'name' : [
            {
                required : true,
                msg : 'name is required'
            },
            {
                maxLength : 140,
                msg : 'Max. 140 characters'
            }
          ],
            'start-timestamp' : {
                fn : function(value) {
                    return this.validateStartTimestamp(value);
                }
            }
        }

    });



    return Poll;

});
